var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJourneyLevelAssessments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8345 41.8978L3.27148 41.7948L8.41648 37.6768L36.9785 37.7798L31.8345 41.8978Z",
    fill: "#172535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41712 37.677L3.27213 41.795L3.20312 13.401L8.34713 9.00195",
    fill: "#172535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5836 7.98408C42.8976 8.00408 42.2466 8.29008 41.7676 8.78208L26.0296 24.5201L19.0946 17.5851C18.0846 16.5331 16.4126 16.4991 15.3606 17.5091C14.3086 18.5191 14.2746 20.1911 15.2846 21.2431C15.3096 21.2691 15.3346 21.2941 15.3606 21.3191L24.1626 30.1211C25.1936 31.1521 26.8656 31.1521 27.8966 30.1211L45.5016 12.5161C46.5466 11.4981 46.5686 9.82608 45.5506 8.78108C45.0346 8.25208 44.3216 7.96208 43.5826 7.98408H43.5836Z",
    fill: "#FD6A3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2489 26.261L34.2279 35.078L10.9259 35.081L11.0369 11.716L34.2839 11.806L34.2789 13.777L36.9879 11.068L36.9929 9.11395L8.34694 9.00195L8.21094 37.784L36.9239 37.78L36.9579 23.552L34.2489 26.261Z",
    fill: "#172535"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6596 7.98196C44.3706 7.98196 45.0536 8.26896 45.5516 8.77996C46.5696 9.82496 46.5476 11.497 45.5026 12.515L27.8976 30.12C27.3816 30.635 26.7066 30.893 26.0306 30.893C25.3546 30.893 24.6796 30.635 24.1636 30.12L15.3606 21.317C15.3346 21.292 15.3096 21.267 15.2846 21.241C14.2746 20.189 14.3086 18.517 15.3606 17.507C15.8726 17.015 16.5316 16.771 17.1896 16.771C17.8836 16.771 18.5766 17.043 19.0946 17.583L26.0296 24.518L41.7676 8.77996C42.2466 8.28796 42.8976 8.00196 43.5836 7.98196C43.6086 7.98196 43.6346 7.98096 43.6596 7.98096",
    fill: "#FD6A3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyLevelAssessments);
export default __webpack_public_path__ + "static/media/journeyLevelAssessments.4a8670659028c5620e6de136ef734c5c.svg";
export { ForwardRef as ReactComponent };